import { handleActions } from "redux-actions";
import { createReducer } from "../baseReducer/baseReducer";
import { api } from "api";
import { NotificationManager } from "react-notifications";
import moment from "moment";

// ------------------------------------
// Constants
// ------------------------------------
const FILTER_BY_STATION_STATION_REPORT = "FILTER_BY_STATION_STATION_REPORT";
const FILTER_BY_START_DATE_STATION_REPORT =
    "FILTER_BY_START_DATE_STATION_REPORT";
const FILTER_BY_END_DATE_STATION_REPORT =
    "FILTER_BY_END_DATE_STATION_REPORT";
const FILTER_BY_TYPE_EMERGENCY_STATION_REPORT =
    "FILTER_BY_TYPE_EMERGENCY_STATION_REPORT";

const setFilterByStation = (station) => ({
    type: FILTER_BY_STATION_STATION_REPORT,
    station,
});

const setFilterByStartDate = (start_date) => ({
    type: FILTER_BY_START_DATE_STATION_REPORT,
    start_date,
});

const setFilterByEndDate = (end_date) => ({
    type: FILTER_BY_END_DATE_STATION_REPORT,
    end_date,
});

const setFilterByTypeEmergency = (emergency_type_id) => ({
    type: FILTER_BY_TYPE_EMERGENCY_STATION_REPORT,
    emergency_type_id,
});

const setExcelLoading = (payload) => ({
    type: 'SET_EXCEL_LOADING',
    payload,
});

const setExcelProgress = (payload) => ({
    type: 'SET_EXCEL_PROGRESS',
    payload,
});

export const baseReducer = createReducer(
    "station_report",
    "reports/report_station",
    "ListReportStations"
);

const descargarExcel = () => (dispatch, getStore) => {
    const resource = getStore()["station_report"];

    // filter emergency type
    const emergency_type_id = resource.emergency_type_id
        ? resource.emergency_type_id.map((emergency) => emergency.id)
        : "";

    // filter station
    const station_id = resource.station
        ? resource.station.map((station) => station.id)
        : "";

    // filter start date
    const start_date = resource.start_date
        ? moment(resource.start_date).format("YYYY-MM-DD")
        : "";
    // filter end date
    const end_date = resource.end_date
        ? moment(resource.end_date).format("YYYY-MM-DD")
        : "";

    const params = {
        station: station_id,
        emergency_type_id,
        start_date,
        end_date
    };

    dispatch(setExcelLoading(true));
    dispatch(setExcelProgress(0));

    api.getWithProgress("reports/download_excel_stations", params, (percent) => {
        dispatch(setExcelProgress(percent));
    })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_Estaciones.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(() => {
            NotificationManager.error('Error al descargar', 'ERROR');
        }).finally(() => {
            dispatch(setExcelLoading(false));
            dispatch(setExcelProgress(0));
        });
};

const listarReport =
    (page = 1) =>
        (dispatch, getStore) => {
            const resource = getStore()["station_report"];
            const params = { page };

            // filter emergency type
            const emergency_type_id = resource.emergency_type_id
                ? resource.emergency_type_id.map((emergency) => emergency.id)
                : "";
            params.emergency_type_id = emergency_type_id;

            // filter station
            const station_id = resource.station
                ? resource.station.map((station) => station.id)
                : "";
            params.station = station_id;

            // filter start date
            const start_date = resource.start_date
                ? moment(resource.start_date).format("YYYY-MM-DD")
                : "";
            params.start_date = start_date;
            // filter end date
            const end_date = resource.end_date
                ? moment(resource.end_date).format("YYYY-MM-DD")
                : "";
            params.end_date = end_date;

            if (start_date && end_date)
                if (end_date < start_date)
                    return NotificationManager.error(
                        "La fecha inicial no puede ser mayor a la fecha final",
                        "ERROR",
                        0
                    );

            dispatch(baseReducer.actions.setLoader(true));
            api.get("reports/report_station", params)
                .then((response) => {
                    dispatch(baseReducer.actions.setData(response));
                    dispatch(baseReducer.actions.setPage(page));
                })
                .catch(() => { })
                .finally(() => {
                    dispatch(baseReducer.actions.setLoader(false));
                });
        };

const setStation = (value) => (dispatch, getStore) => {
    dispatch(setFilterByStation(value));
    dispatch(listarReport());
};

const setTypeEmergency = (value) => (dispatch, getStore) => {
    dispatch(setFilterByTypeEmergency(value));
    dispatch(listarReport());
};

const setStartDate = (value) => (dispatch, getStore) => {
    const resource = getStore()["station_report"];
    dispatch(setFilterByStartDate(value));
    if (resource.end_date) dispatch(listarReport());
};

const setEndDate = (value) => (dispatch, getStore) => {
    const resource = getStore()["station_report"];
    dispatch(setFilterByEndDate(value));
    if (resource.start_date) dispatch(listarReport());
};

export const actions = {
    listarReport,
    setStation,
    setTypeEmergency,
    setStartDate,
    setEndDate,
    descargarExcel,
    ...baseReducer.actions,
};

export const reducers = {
    ...baseReducer.reducers,
    [FILTER_BY_STATION_STATION_REPORT]: (state, { station }) => {
        return {
            ...state,
            station,
        };
    },
    [FILTER_BY_TYPE_EMERGENCY_STATION_REPORT]: (
        state,
        { emergency_type_id }
    ) => {
        return {
            ...state,
            emergency_type_id,
        };
    },
    [FILTER_BY_START_DATE_STATION_REPORT]: (state, { start_date }) => {
        return {
            ...state,
            start_date,
        };
    },
    [FILTER_BY_END_DATE_STATION_REPORT]: (state, { end_date }) => {
        return {
            ...state,
            end_date,
        };
    },
    ['SET_EXCEL_LOADING']: (state, { payload }) => ({ ...state, excelLoading: payload }),
    ['SET_EXCEL_PROGRESS']: (state, { payload }) => ({ ...state, excelProgress: payload }),
};

export const initialState = {
    ...baseReducer.initialState,
    station: "",
    start_date: "",
    end_date: "",
    emergency_type_id: "",
    excelLoading: false,
    excelProgress: 0,
};

export default handleActions(reducers, initialState);
